"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amex = void 0;
var React = __importStar(require("react"));
var Amex = function () {
    return (React.createElement("svg", { width: 36, height: 27, viewBox: "0 0 36 27", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { filter: "url(#filter0_d_277_4952)" },
            React.createElement("g", { filter: "url(#filter1_d_277_4952)" },
                React.createElement("rect", { x: 1, y: 1, width: 34, height: 24, rx: 4, fill: "#006FCF" })),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.095 9.5l-3.18 7.247h3.807l.472-1.156h1.08l.472 1.156h4.191v-.882l.374.882h2.168l.374-.9v.9h8.718l1.06-1.126.992 1.126 4.478.01-3.191-3.613L32.1 9.5h-4.407l-1.032 1.105-.962-1.105h-9.483l-.815 1.87-.833-1.87h-3.8v.852l-.423-.852h-3.25zm.737 1.029h1.856l2.11 4.914V10.53h2.034l1.63 3.523 1.502-3.523h2.023v5.2h-1.231l-.01-4.075-1.795 4.075H14.85l-1.805-4.075v4.075h-2.533l-.48-1.166H7.437l-.479 1.165H5.601l2.231-5.199zm17.288 0h-5.007v5.197h4.93l1.588-1.722 1.53 1.722h1.601l-2.326-2.583 2.326-2.614h-1.53l-1.581 1.703-1.531-1.703zm-16.385.88l-.855 2.077H9.59l-.854-2.077zm12.615 1.146v-.95h3.123l1.363 1.518-1.423 1.526H21.35v-1.036h2.73v-1.058h-2.73z", fill: "#fff" })),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_277_4952", x: 0, y: 0.5, width: 36, height: 26, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 0.5 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5 }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" }),
                React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_277_4952" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_277_4952", result: "shape" })),
            React.createElement("filter", { id: "filter1_d_277_4952", x: 0, y: 0.5, width: 36, height: 26, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 0.5 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5 }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" }),
                React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_277_4952" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_277_4952", result: "shape" })))));
};
exports.Amex = Amex;
